import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {gsap} from "gsap";

/**
 * Created by jonas on 2021-03-29.
 */

export class CountUpMultiplier extends PIXI.Container{
    private _multiplierBack:PIXI.BitmapText;
    private _multiplierFront:PIXI.BitmapText;

    constructor() {
        super();
        const multiplierTextStyle = {
            fontName:DasUBootGameAssets.BITMAP_FONT_MULTIPLIER,
            fontSize:156,
            tint:0xffffff,
        };
        this._multiplierBack = new PIXI.BitmapText("", multiplierTextStyle);
        this._multiplierBack.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplierBack.alpha = 1;

        this._multiplierFront = new PIXI.BitmapText("", multiplierTextStyle);
        this._multiplierFront.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplierFront.alpha = 1;

        this.addChild(this._multiplierBack, this._multiplierFront);
    }


    public reset() {
        this._multiplierBack.alpha = 0;
        this._multiplierFront.alpha = 0;
        this._multiplierFront.text = "";
        this._multiplierBack.text = "";
    }

    public getAnimation(multiplier:number, duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if (multiplier <= 2) {
            this.reset();
        }

        tl.add(() => {
            this._multiplierFront.text = "X" + multiplier;
        });

        //Front
        tl.add(gsap.fromTo(this._multiplierFront, {
                pixi:{scale:1.6, alpha:0}
            },
            {
                duration:duration,
                ease:"power2.in",
                pixi:{scale:1, alpha:1}
            })
        );

        //back
        tl.add(gsap.to(this._multiplierBack, {
                duration:duration,
                ease:"power2.in",
                pixi:{scale:0, alpha:0}
            }),
            "<"
        );

        tl.add(() => {
            this._multiplierFront.alpha = 0;

            this._multiplierBack.text = "X" + multiplier;
            this._multiplierBack.alpha = 1;
            this._multiplierBack.scale.set(1, 1);
        });


        return tl;
    }


}